import { render } from "./ProductBulkUpdateModal.vue?vue&type=template&id=529c8b9a&scoped=true"
import script from "./ProductBulkUpdateModal.vue?vue&type=script&lang=js"
export * from "./ProductBulkUpdateModal.vue?vue&type=script&lang=js"

import "./ProductBulkUpdateModal.vue?vue&type=style&index=0&id=529c8b9a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529c8b9a"],['__file',"resources/js/components/admin/products/ProductBulkUpdateModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "529c8b9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('529c8b9a', __exports__)) {
    api.reload('529c8b9a', __exports__)
  }
  
  module.hot.accept("./ProductBulkUpdateModal.vue?vue&type=template&id=529c8b9a&scoped=true", () => {
    api.rerender('529c8b9a', render)
  })

}


export default __exports__